import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import Config from '../../Core/Config.js';
import { framework } from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import { libs, ui } from 'saffroncodejs';
var PageManager = framework.PageManager;

class BarbariSaderati extends React.Component {
    constructor(props) {
        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.state = {
            isLoading: true,
            activeTab: 1,
            data: { "UserId": "60b62129-b2d5-4db8-a275-e19bc5faa7fc", "UserTypeBaseId": "23", "UserTypeBaseTitle": null, "UserTypeLanguageBaseId": 0, "FirstName": "مریم", "LastName": "مالکی", "EMailAddress": "maryam_22_11_66@yahoo.com", "MobileNo": "09127012470", "UserName": "maryam", "Password": null, "IsActive": "True", "Version": null, "ConfirmNumber": null, "IsConfirmed": "True", "IsBlocked": false, "BlockedNote": null, "PhotoName": "", "AcceptedPhotos": "", "WonPhotos": "", "BirthDate": "", "GenderTypeBaseId": "32", "GenderTypeLanguageBaseId": 0, "GenderTypeBaseTitle": "", "AllLikeCount": "0", "CityId": "1", "Adress": "تهران", "TotalPhotos": "0", "TotalRefereeScore": "0", "AuthorizedSurveyIds": null, "Description": "کاربر تستی", "PostalCode": "0078436893", "IsPictureConfirmed": null }
        }
        this.state.data = {};

        this.state.btns = [];

        this.loadDetail();

    }
    encodeSodurId(encodedId) {
        return encodedId;
    }

    componentWillReceiveProps(props) {
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);

        this.loadDetail();
    }

    loadDetail() {
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Br/api/BrS/PolicyInfo",

                { id: this.currentSodurId, codeMelli: UserManager.MelliCode() }
            ),
            BimeManager.header())
            .then((result) => {
                this.setState({ data: result.data, isLoading: false })
                console.log('BarbariSaderati***',this.state.data);
            })
            .catch((error) => { alert(error) })
    }
    pagechange(bid,reshte) {

        PageManager.changePage(Config.p_pardakhtman, [bid,reshte]);
    }
    
    render() {
        
        return (

            <div>
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>باربری صادراتی</h4>
                    </Col>
                </Row>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 1 }}
                            onClick={() => { this.setState({ activeTab: 1 }) }}>
                            جزئیات
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 2 }}
                            onClick={() => { this.setState({ activeTab: 2 }) }}>
                            الحاقیه
                        </NavLink>
                    </NavItem>

                    <NavItem>
                        <NavLink onClick={() => { this.pagechange(this.currentSodurId,this.state.data.Reshte) }}>
                            پرداخت شده ها
                        </NavLink>
                    </NavItem>
                </Nav>


                {(!this.state.isLoading) ? (


                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId={1}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            <Col sm="12"><span className="bold-head">شماره بيمه نامه:</span>{this.state.data.FullBNo}</Col>
                                            <Col sm="12"><span className="bold-head">تاريخ صدور:</span>{this.state.data.BNsodurDate}</Col>
                                            <Col sm="12"><span className="bold-head">شماره درخواست:</span>{this.state.data.PishnahadNo}</Col>
                                            <Col sm="12"><span className="bold-head">تاريخ درخواست:</span>{this.state.data.PishnahadDate}</Col>
                                            <Col sm="12"><span className="bold-head">كد نماينده/كارگزار بيمه:</span>{this.state.data.AgentText}</Col>
                                            <Col sm="12"><span className="bold-head">شماره گواهي بيمه:</span>{this.state.data.GovahiNo}</Col>
                                            <Col sm="12"><span className="bold-head">بيمه گذار:</span>{this.state.data.BimeGozarName}</Col>
                                            <Col sm="12"><span className="bold-head">نشانی:</span>{this.state.data.BimeGozarAddress}</Col>
                                            <Col sm="12"><span className="bold-head">تلفن:</span>{this.state.data.Tel}</Col>
                                            <Col sm="12"><span className="bold-head">کد ملی:</span>{this.state.data.CodeMelli}</Col>
                                            <Col sm="12"><span className="bold-head">مورد بيمه:</span>{this.state.data.MoredBimeText}</Col>
                                            <Col sm="12"><span className="bold-head">نوع بسته بندی:</span>{this.state.data.BasteBandiText}</Col>
                                            <Col sm="12"><span className="bold-head">شماره وتاريخ پروفرما:</span>{this.state.data.ProfermaText}</Col>
                                            <Col sm="12"><span className="bold-head">مبدا:</span>{this.state.data.SrcText}</Col>
                                            <Col sm="12"><span className="bold-head">مقصد:</span>{this.state.data.DstText}</Col>
                                            <Col sm="12"><span className="bold-head">از طريق:</span>{this.state.data.MarzText}</Col>
                                            <Col sm="12"><span className="bold-head">وسيله حمل:</span>{this.state.data.VasileHamlText}</Col>
                                            <Col sm="12"><span className="bold-head">نوع قرارداد خريد:</span>{this.state.data.BuyKindText}</Col>
                                            <Col sm="12"><span className="bold-head">علامت و شماره:</span>{this.state.data.SabtNo}</Col>
                                            <Col sm="12"><span className="bold-head">سرمايه بيمه شده به ارز:</span>{this.state.data.SarmayeArzi}</Col>
                                            <Col sm="12"><span className="bold-head">نام ارز:</span>{this.state.data.SArzText}</Col>
                                            <Col sm="12"><span className="bold-head">نرخ ارز:</span>{libs.StringFunctions.currancyPrint(this.state.data.SArzNerkh)}</Col>
                                            <Col sm="12"><span className="bold-head">در صد افزايش:</span>{this.state.data.DarsadAfzudeText}</Col>
                                            <Col sm="12"><span className="bold-head">سرمايه بيمه شده به ريال:</span>{libs.StringFunctions.currancyPrint(this.state.data.SarmayeRiali) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">كل سرمايه بيمه شده به ارز:</span><ul className="ul_arz">{this.state.data.SarmayeArziAndKerayeHamlText? this.state.data.SarmayeArziAndKerayeHamlText.split(/[+]/g ).map(t => {
                                        
                                            return <ol className='textItem'>{t}<br/><span>+</span></ol>;
                                            }):''}
                                             </ul></Col>
                                            <Col sm="12"><span className="bold-head">حق بيمه:</span>{libs.StringFunctions.currancyPrint(this.state.data.HBRiali) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(this.state.data.AfzoodehMaliat) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(this.state.data.ShahrdariAvarez) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">حق بيمه قابل پرداخت:</span>{libs.StringFunctions.currancyPrint(this.state.data.HbRialiWithAvarez) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">واحد صدور:</span>{this.state.data.SodurName}</Col>
                                            <Col sm="12"><span className="bold-head">نشاني واحد صدور:</span>{this.state.data.address}</Col>
                                            <Col sm="12"><span className="bold-head">کل سرمایه بیمه شده به ریال:</span>{this.state.data.SarmayeRialiText}</Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        <TabPane tabId={2}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            {
                                                //alert('bill***'+this.state.data.Bill)
                                                (this.state.data.Endorsement) ? this.state.data.Endorsement.map((endorsement) => {
                                                    return <div className="border-List">
                                                        <Col sm="12"><span className="bold-head">نوع بیمه نامه:</span>{endorsement.BimenameKind}</Col>
                                                        <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{endorsement.BId}</Col>
                                                        <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{endorsement.FullBNo}</Col>
                                                        <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{endorsement.ElhNo}</Col>
                                                        <Col sm="12"><span className="bold-head">شماره ردیف سالانه:</span>{endorsement.Radif}</Col>
                                                        <Col sm="12"><span className="bold-head">تاریخ صدور:</span>{endorsement.VSodurDate}</Col>
                                                        <Col sm="12"><span className="bold-head">نماینده/کارگزار:</span>{endorsement.AgentCodeText}</Col>
                                                        <Col sm="12"><span className="bold-head">واحد صدور:</span>{endorsement.CodeSodurText}</Col>
                                                        <Col sm="12"><span className="bold-head">تاریخ اعمال:</span>{endorsement.ActiveDate}</Col>
                                                        <Col sm="12"><span className="bold-head">بیمه گذار:</span>{endorsement.BimeGozarText}</Col>
                                                        <Col sm="12"><span className="bold-head">شرح:</span>{endorsement.Sharh}</Col>
                                                        <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(endorsement.VAfzoodehMaliat) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(endorsement.VShahrdariAvarez) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">حق بیمه اضافی:</span>{libs.StringFunctions.currancyPrint(endorsement.HB_EzafiwithAvarez) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">حق بیمه برگشتی:</span>{libs.StringFunctions.currancyPrint(endorsement.HB_BarghashtiWithoutAvarez) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">حق بیمه اضافی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.HB_EzafiwithAvarez) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">حق بیمه برگشتی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.HB_BarghashtiwithAvarez) + ('ریال')}</Col>
                                                        <br />
                                                    </div>

                                                }) : ''
                                            }

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>



                    </TabContent>) : (<ui.Preloader />)



                }
            </div>
        );
    }
}


export default BarbariSaderati;


// WEBPACK FOOTER //
// ./src/components/ListCollapse/BarbariSaderati.js